import styled from 'styled-components';
import { mobile } from '../../../styles/variables';

export const Container = styled.div`
    width: 100%;
    margin: 2rem 0;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 0;
`;

export const Wrapper = styled.div`
    position: relative;
    padding: 50px;
    margin: 1rem 0;
    background: linear-gradient(rgba(240, 240, 240, 1) 0%, #fff 100%);
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
    font-family: 'Courier New', Courier, monospace;
    color: black;

    h1,
    h2,
    h3,
    h4,
    h5 {
        margin-top: 0;
        margin-bottom: 0.5rem;
    }

    @media ${mobile} {
        width: 90%;
        align-self: center;
    }

    :before,
    :after {
        content: '';
        box-shadow: 1px 3px 5px rgba(0, 0, 0, 0.2), inset 1px 1px 50px rgba(0, 0, 0, 0.2);
        //box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.25);
        position: absolute;
        height: 95%;
        width: 99%;
        background-color: #eee;
    }

    :before {
        right: 10px;
        top: 0;
        transform: rotate(-0.5deg);
        z-index: -1;
    }

    :after {
        top: 5px;
        right: -5px;
        transform: rotate(1deg);
        z-index: -2;
    }
`;
